import _ from 'lodash'

const mirrorNodeAttrs = [
  'name',
  'visible',
  'width',
  'height',
  'anchoredX',
  'anchoredY',
  'pivotX',
  'pivotY',
  'scaleX',
  'scaleY',
  'rotation',
  'alpha',
  'text',
  'lineSpacing',
  'color',
  'fontSize',
  'bold',
  'wrap',
  'strokeThickness',
  'italic',
  'stroke',
  'enableGlow',
  'enableShadow',
  'shadowColor',
  'glowColor',
  'shadowBlur',
  'shadowOffsetX',
  'shadowOffsetY',
  'alignH',
  'alignV',
  'glowBlur',
  'texture',
  'uniqueName',
  'zoneType',
  'zoneHeight',
  'zoneLength',
  'zoneRadius',
  'zoneRotation',
  'zoneWidth',
  'edgeEmission',
  'emissionSpace',
  'frequency',
  'quantity',
  'repeat',
  'delay',
  'lifespan',
  'angle',
  'blendMode',
  'startAlpha',
  'startScale',
  'startColor',
  'startColorVariation',
  'endColor',
  'endColorVariation',
  'startVelocity',
  'startRotation',
  'angularVelocity',
  'gravity',
  'gravityX',
  'gravityY',
  'gradient',
  'maxParticles',
  'playOnAwake',
  'enableColorCurve',
  'colorCurve',
  'enableAlphaCurve',
  'alphaCurve',
  'enableScaleCurve',
  'scaleCurve',
  'enableVelocityCurve',
  'velocityCurve',
  'enableAngularVelocityCurve',
  'angularVelocityCurve',
  'colorTint',
  'x',
  'y',
  'scripts',
  'enableUnderline',
  'underlineColor',
  'underlineWidth',
  'underlineSpacing',
  'enableDeleteline',
  'deletelineColor',
  'deletelineWidth',
  'deletelineSpacing',
  'letterSpacing',
  'uuid',
  'lineHeight',
  'font',
  'fontFamily'
]

export function getMirrorNodeAttrs(node) {
  return _.pick(node, mirrorNodeAttrs)
}

/**
 * activeNode 在某些场景下无法与编辑器UI联动，所以增加 mirrorNode
 * @param target
 * @param trigger
 * @returns {boolean|any}
 */
export function reactive(target, trigger) {
  const handler = {
    get(target, key, receiver) {
      return Reflect.get(target, key, receiver)
    },
    set(target, key, value, receiver) {
      const result = Reflect.set(target, key, value, receiver)
      // 只有特定属性才需要触发
      if (mirrorNodeAttrs.some(item => item === key)) {
        trigger(key, value)
      }
      return result
    }
  }
  return new Proxy(target, handler)
}
